/**
 * @flow
 * @relayHash 79a34e8df5af33c263c783e8b5498c89
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AddUpdateItemModal_defaultForm$ref = any;
type ItemsTable_defaultForm$ref = any;
type PaginatedItemsContainer_items$ref = any;
export type FormType = "ITEM" | "JOB_STEP" | "JOB_TASK" | "JOB_YIELD";
export type ItemSortField = "BOM_NUMBER" | "CREATED_AT" | "ITEM_NUMBER" | "NAME" | "PART_NUMBER" | "UPDATED_AT";
export type Permission = "CREATE_API_KEY" | "CREATE_CUSTOMER" | "CREATE_INVOICE" | "CREATE_ITEM" | "CREATE_JOB" | "CREATE_LOT" | "CREATE_ORDER" | "CREATE_PAYMENT" | "CREATE_SHIPMENT" | "DELETE_API_KEY" | "DELETE_CUSTOMER" | "DELETE_INVOICE" | "DELETE_ITEM" | "DELETE_JOB" | "DELETE_LOT" | "DELETE_ORDER" | "DELETE_SHIPMENT" | "READ_API_KEY" | "READ_CUSTOMER" | "READ_INVOICE" | "READ_ITEM" | "READ_JOB" | "READ_LOT" | "READ_ORDER" | "READ_PAYMENT" | "READ_SHIPMENT" | "UPDATE_API_KEY" | "UPDATE_CUSTOMER" | "UPDATE_INVOICE" | "UPDATE_ITEM" | "UPDATE_JOB" | "UPDATE_LOT" | "UPDATE_ORDER" | "UPDATE_SHIPMENT";
export type SortDirection = "ASC" | "DESC";
export type ItemSort = {|
  field: ItemSortField,
  direction: SortDirection,
|};
export type ItemsQueryVariables = {|
  count: number,
  search?: ?string,
  cursor?: ?string,
  sortBy?: ?ItemSort,
  partNumber?: ?string,
  itemNumbers?: ?$ReadOnlyArray<string>,
  orderIds?: ?$ReadOnlyArray<string>,
  customerIds?: ?$ReadOnlyArray<string>,
  itemCategoryIds?: ?$ReadOnlyArray<string>,
|};
export type ItemsQueryResponse = {|
  +viewer: ?{|
    +id: string,
    +permissions: $ReadOnlyArray<Permission>,
  |},
  +forms: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +type: FormType,
        +$fragmentRefs: AddUpdateItemModal_defaultForm$ref & ItemsTable_defaultForm$ref,
      |}
    |}>
  |},
  +$fragmentRefs: PaginatedItemsContainer_items$ref,
|};
export type ItemsQuery = {|
  variables: ItemsQueryVariables,
  response: ItemsQueryResponse,
|};
*/


/*
query ItemsQuery(
  $search: String
  $sortBy: ItemSort
  $partNumber: String
  $itemNumbers: [String!]
  $orderIds: [ID!]
  $customerIds: [ID!]
  $itemCategoryIds: [ID!]
) {
  ...PaginatedItemsContainer_items_2JSmq2
  viewer {
    id
    permissions
  }
  forms(types: [ITEM]) {
    edges {
      node {
        id
        type
        ...AddUpdateItemModal_defaultForm
        ...ItemsTable_defaultForm
      }
    }
  }
}

fragment PaginatedItemsContainer_items_2JSmq2 on Query {
  items(first: 30, search: $search, sortBy: $sortBy, partNumber: $partNumber, itemNumbers: $itemNumbers, orderIds: $orderIds, customerIds: $customerIds, itemCategoryIds: $itemCategoryIds) {
    edges {
      cursor
      ...ItemsTable_itemEdges
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment AddUpdateItemModal_defaultForm on Form {
  id
  type
  name
  systemKey
  productionType {
    id
  }
  fields {
    id
    systemKey
    type
    name
    description
    placeholder
    isRequired
    isCreatable
    applicationType
    displayOrder
    properties
    options {
      name
      value
      id
    }
  }
}

fragment ItemsTable_defaultForm on Form {
  id
  name
  type
  systemKey
  productionType {
    id
  }
  fields {
    id
    systemKey
    type
    name
    description
    placeholder
    isRequired
    isCreatable
    applicationType
    displayOrder
    properties
    options {
      name
      value
      id
    }
  }
  ...AddUpdateItemModal_defaultForm
}

fragment ItemsTable_itemEdges on ItemEdge {
  node {
    id
    itemNumber
    name
    partNumber
    category {
      id
      name
    }
    quantityUOM {
      id
      symbol
    }
    totalQty
    safetyQuantity
    totalValue
    ...AddUpdateItemModal_item
    ...DeleteItemModal_item
  }
}

fragment AddUpdateItemModal_item on Item {
  id
  name
  upc
  partNumber
  bomNumber
  description
  category {
    id
    name
  }
  quantityUOM {
    id
    name
    type
    symbol
  }
  weightUOM {
    id
    name
    type
    symbol
  }
  dimensionUOM {
    id
    name
    type
    symbol
  }
  form {
    id
    name
    type
    systemKey
    productionType {
      id
    }
    fields {
      id
      systemKey
      type
      name
      description
      placeholder
      isRequired
      isCreatable
      applicationType
      displayOrder
      properties
      options {
        name
        value
        id
      }
      ...AdditionalFieldInfo_formField
    }
  }
  formFieldValues
  dimensionLength
  dimensionWidth
  dimensionHeight
  weight
  lotTracking
  cost
  sellingPrice
  safetyQuantity
  totalValue
  defaultLocation {
    id
    name
  }
}

fragment DeleteItemModal_item on Item {
  id
  name
}

fragment AdditionalFieldInfo_formField on FormField {
  id
  name
  type
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "ItemSort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "partNumber",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemNumbers",
    "type": "[String!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "customerIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemCategoryIds",
    "type": "[ID!]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "viewer",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "permissions",
      "args": null,
      "storageKey": null
    }
  ]
},
v3 = [
  {
    "kind": "Literal",
    "name": "types",
    "value": [
      "ITEM"
    ]
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "Variable",
  "name": "customerIds",
  "variableName": "customerIds"
},
v6 = {
  "kind": "Variable",
  "name": "itemCategoryIds",
  "variableName": "itemCategoryIds"
},
v7 = {
  "kind": "Variable",
  "name": "itemNumbers",
  "variableName": "itemNumbers"
},
v8 = {
  "kind": "Variable",
  "name": "orderIds",
  "variableName": "orderIds"
},
v9 = {
  "kind": "Variable",
  "name": "partNumber",
  "variableName": "partNumber"
},
v10 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v11 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v12 = [
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v14 = [
  (v1/*: any*/),
  (v13/*: any*/)
],
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v17 = [
  (v1/*: any*/),
  (v13/*: any*/),
  (v4/*: any*/),
  (v15/*: any*/)
],
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "systemKey",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "productionType",
  "storageKey": null,
  "args": null,
  "concreteType": "ProductionType",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ]
},
v20 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "fields",
  "storageKey": null,
  "args": null,
  "concreteType": "FormField",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v18/*: any*/),
    (v4/*: any*/),
    (v13/*: any*/),
    (v16/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "placeholder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isRequired",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isCreatable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "applicationType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayOrder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "properties",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "options",
      "storageKey": null,
      "args": null,
      "concreteType": "FormFieldOption",
      "plural": true,
      "selections": [
        (v13/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "value",
          "args": null,
          "storageKey": null
        },
        (v1/*: any*/)
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ItemsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      (v2/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "forms",
        "storageKey": "forms(types:[\"ITEM\"])",
        "args": (v3/*: any*/),
        "concreteType": "FormConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "FormEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Form",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "AddUpdateItemModal_defaultForm",
                    "args": null
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "ItemsTable_defaultForm",
                    "args": null
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "PaginatedItemsContainer_items",
        "args": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ItemsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "items",
        "storageKey": null,
        "args": (v12/*: any*/),
        "concreteType": "ItemConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemEdge",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "itemNumber",
                    "args": null,
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "partNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "category",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemCategory",
                    "plural": false,
                    "selections": (v14/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "quantityUOM",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UOM",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v15/*: any*/),
                      (v13/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalQty",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "safetyQuantity",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalValue",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "upc",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "bomNumber",
                    "args": null,
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "weightUOM",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UOM",
                    "plural": false,
                    "selections": (v17/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "dimensionUOM",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UOM",
                    "plural": false,
                    "selections": (v17/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "form",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Form",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v13/*: any*/),
                      (v4/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "formFieldValues",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dimensionLength",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dimensionWidth",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dimensionHeight",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "weight",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lotTracking",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cost",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sellingPrice",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "defaultLocation",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WarehouseLocation",
                    "plural": false,
                    "selections": (v14/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "items",
        "args": (v12/*: any*/),
        "handle": "connection",
        "key": "PaginatedItemsContainer_items",
        "filters": []
      },
      (v2/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "forms",
        "storageKey": "forms(types:[\"ITEM\"])",
        "args": (v3/*: any*/),
        "concreteType": "FormConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "FormEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Form",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v4/*: any*/),
                  (v13/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ItemsQuery",
    "id": null,
    "text": "query ItemsQuery(\n  $search: String\n  $sortBy: ItemSort\n  $partNumber: String\n  $itemNumbers: [String!]\n  $orderIds: [ID!]\n  $customerIds: [ID!]\n  $itemCategoryIds: [ID!]\n) {\n  ...PaginatedItemsContainer_items_2JSmq2\n  viewer {\n    id\n    permissions\n  }\n  forms(types: [ITEM]) {\n    edges {\n      node {\n        id\n        type\n        ...AddUpdateItemModal_defaultForm\n        ...ItemsTable_defaultForm\n      }\n    }\n  }\n}\n\nfragment PaginatedItemsContainer_items_2JSmq2 on Query {\n  items(first: 30, search: $search, sortBy: $sortBy, partNumber: $partNumber, itemNumbers: $itemNumbers, orderIds: $orderIds, customerIds: $customerIds, itemCategoryIds: $itemCategoryIds) {\n    edges {\n      cursor\n      ...ItemsTable_itemEdges\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AddUpdateItemModal_defaultForm on Form {\n  id\n  type\n  name\n  systemKey\n  productionType {\n    id\n  }\n  fields {\n    id\n    systemKey\n    type\n    name\n    description\n    placeholder\n    isRequired\n    isCreatable\n    applicationType\n    displayOrder\n    properties\n    options {\n      name\n      value\n      id\n    }\n  }\n}\n\nfragment ItemsTable_defaultForm on Form {\n  id\n  name\n  type\n  systemKey\n  productionType {\n    id\n  }\n  fields {\n    id\n    systemKey\n    type\n    name\n    description\n    placeholder\n    isRequired\n    isCreatable\n    applicationType\n    displayOrder\n    properties\n    options {\n      name\n      value\n      id\n    }\n  }\n  ...AddUpdateItemModal_defaultForm\n}\n\nfragment ItemsTable_itemEdges on ItemEdge {\n  node {\n    id\n    itemNumber\n    name\n    partNumber\n    category {\n      id\n      name\n    }\n    quantityUOM {\n      id\n      symbol\n    }\n    totalQty\n    safetyQuantity\n    totalValue\n    ...AddUpdateItemModal_item\n    ...DeleteItemModal_item\n  }\n}\n\nfragment AddUpdateItemModal_item on Item {\n  id\n  name\n  upc\n  partNumber\n  bomNumber\n  description\n  category {\n    id\n    name\n  }\n  quantityUOM {\n    id\n    name\n    type\n    symbol\n  }\n  weightUOM {\n    id\n    name\n    type\n    symbol\n  }\n  dimensionUOM {\n    id\n    name\n    type\n    symbol\n  }\n  form {\n    id\n    name\n    type\n    systemKey\n    productionType {\n      id\n    }\n    fields {\n      id\n      systemKey\n      type\n      name\n      description\n      placeholder\n      isRequired\n      isCreatable\n      applicationType\n      displayOrder\n      properties\n      options {\n        name\n        value\n        id\n      }\n      ...AdditionalFieldInfo_formField\n    }\n  }\n  formFieldValues\n  dimensionLength\n  dimensionWidth\n  dimensionHeight\n  weight\n  lotTracking\n  cost\n  sellingPrice\n  safetyQuantity\n  totalValue\n  defaultLocation {\n    id\n    name\n  }\n}\n\nfragment DeleteItemModal_item on Item {\n  id\n  name\n}\n\nfragment AdditionalFieldInfo_formField on FormField {\n  id\n  name\n  type\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1b883fc76a754899d06947aedf8c4e1d';
module.exports = node;
